import React from "react"
import {
  Box,
  BasicInfoContainer,
  IconCover,
  InfoCard,
  InfoCards,
  InfoCover,
  InfoSec,
  Title,
} from "./basicStyles"
import { StaticImage } from "gatsby-plugin-image"
import data from "../../../assets/data.json"
import "./basicinfo.scss"

const BasicInfo = (props) => {
  const { isCertificate } = props
  const {
    duration,
    netFee,
    courseReference,
    trainingMode,
    slug,
    price,
    skillsCode,
    skillsCodeName,
  } = props
  return (
    <>
      <BasicInfoContainer>
        <InfoSec>
          <InfoCards>
            <InfoCard>
              <IconCover id="location">
                <StaticImage
                  src="../../../assets/images/location.png"
                  alt="location"
                />
              </IconCover>
              <InfoCover>
                <h4>Our Location</h4>
                <h5>
                  {data.address}
                </h5>
              </InfoCover>
            </InfoCard>
            <div className="row timing">
              <div className="col-xl-6 col-md-6 col-lg-6">
                {trainingMode && (
                  <IconCover>
                    <div className="media">
                      <StaticImage
                        src="../../../assets/images/clockicon.png"
                        alt="clockicon"
                      />
                      <div className="media-body">
                        <h4>Training Mode</h4>
                        <h5>{trainingMode}</h5>
                      </div>
                    </div>
                  </IconCover>
                )}
              </div>
              <div className="col-xl-6 col-md-6 col-lg-6">
                {duration && (
                  <div className="media">
                    <StaticImage
                      src="../../../assets/images/clockicon.png"
                      alt="clockicon"
                    />
                    <div className="media-body">
                      <h4>Duration</h4>
                      <h5>{duration} Hours</h5>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-xl-12">
                <button>
                  <StaticImage
                    src="../../../assets/images/map.png"
                    alt="map"
                  />
                  <a href="https://www.google.com/maps?ll=1.356379,103.837476&z=16&t=m&hl=en-US&gl=US&mapclient=embed&cid=6210499622005566020">
                    Open In Google Maps
                  </a>
                </button>
              </div>
            </div>
          </InfoCards>

          <InfoCards>
            <Title>About course</Title>

            <InfoCard>
              <IconCover>
                <StaticImage
                  src="../../../assets/images/Acra_icon.png"
                  alt="Acra_icon"
                />
              </IconCover>
              <InfoCover>
                <h4>ACRA-registered Name</h4>
                <h5>Ace Industrial Academy Pte. Ltd.</h5>
              </InfoCover>
            </InfoCard>
            <InfoCard>
              <IconCover>
                <StaticImage
                  src="../../../assets/images/UEN.png"
                  alt="UEN"
                />
              </IconCover>
              <InfoCover>
                <h4>UEN</h4>
                <h5>200710151K</h5>
              </InfoCover>
            </InfoCard>
            {courseReference && (
              <InfoCard>
                <IconCover>
                  <StaticImage
                    src="../../../assets/images/CourseCode.png"
                    alt="CourseCode"
                  />
                </IconCover>
                <InfoCover>
                  <h4>Course Code</h4>
                  <h5>{courseReference}</h5>
                </InfoCover>
              </InfoCard>
            )}
            {skillsCode && (
              <InfoCard>
                <IconCover>
                  <StaticImage
                    src="../../../assets/images/Skillcode.png"
                    alt="Skillcode"
                  />
                </IconCover>
                <InfoCover>
                  <h4>Skill Code</h4>
                  <h5>{skillsCode}</h5>
                </InfoCover>
              </InfoCard>
            )}
            {skillsCodeName && (
              <InfoCard>
                <IconCover>
                  <StaticImage
                    src="../../../assets/images/SkillCodeName.png"
                    alt="SkillCodeName"
                  />
                </IconCover>
                <InfoCover>
                  <h4>Skill Code Name</h4>
                  <h5>{skillsCodeName}</h5>
                </InfoCover>
              </InfoCard>
            )}
            {duration && (
              <InfoCard>
                <IconCover>
                  <StaticImage
                    src="../../../assets/images/clockicon.png"
                    alt="clockicon"
                  />
                </IconCover>
                <InfoCover>
                  <h4>Duration</h4>
                  <h5>{duration} Hours</h5>
                </InfoCover>
              </InfoCard>
            )}
            {price && (
              <InfoCard>
                <IconCover>
                  <StaticImage
                    src="../../../assets/images/CourseFee.png"
                    alt="CourseFee"
                  />
                </IconCover>
                <InfoCover>
                  <h4>Course Fee</h4>
                  <h5>
                    ${price}{" "}
                    <span className="spanGst">
                      (excluding GST)
                    </span>
                  </h5>
                </InfoCover>
              </InfoCard>
            )}
            {isCertificate && (
              <InfoCard>
                <IconCover>
                  <StaticImage
                    src="../../../assets/images/questionMark.png"
                    alt=""
                  />
                </IconCover>
                <InfoCover>
                  <h4>Questions</h4>
                  <h5>65</h5>
                </InfoCover>
              </InfoCard>
            )}
            <div className="note">
              {netFee && (
                <InfoCard>
                  <IconCover>
                    <StaticImage
                      src="../../../assets/images/NetFee.png"
                      alt="NetFee"
                    />
                  </IconCover>
                  <InfoCover>
                    <h4>
                      Net Fee after Skillsfuture Funding
                    </h4>
                    <h5>
                      ${netFee}{" "}
                      <span className="spanGst">
                        (excluding GST)
                      </span>
                    </h5>
                  </InfoCover>
                </InfoCard>
              )}
              {/* <Box>
                <p>* Fees before gst </p>
              </Box> */}
            </div>

            <InfoCard>
              <IconCover>
                <StaticImage
                  src="../../../assets/images/SkillLevel.png"
                  alt="SkillLevel"
                />
              </IconCover>
              <InfoCover>
                <h4>Skill level</h4>
                <h5>Beginner</h5>
              </InfoCover>
            </InfoCard>
          </InfoCards>
        </InfoSec>
      </BasicInfoContainer>
    </>
  )
}

export default BasicInfo
